<template>
  <div>
    <div class="owner_title">文件下载记录</div>
    <!-- 筛选 -->
    <div class="task_filtrate" @click="show_filter_form()">
      <i class="iconfont icon-shaixuan1"></i>
      <span>筛选</span>
    </div>

    <!-- 筛选表单 -->
    <div class="filter_form" v-show="isFilterForm">
      <el-form
        ref="filter_form"
        :model="filter_form"
        :inline="true"
        class="demo-form-inline"
        label-width="100px"
      >
        <el-form-item label="金主昵称" prop="connection_name">
          <el-input v-model="filter_form.connection_name"></el-input>
        </el-form-item>
        <el-form-item label="书名" prop="connectionessay_name">
          <el-input v-model="filter_form.connectionessay_name"></el-input>
        </el-form-item>
        <el-form-item label="写手编辑昵称" prop="writeradmin_name">
          <el-input v-model="filter_form.writeradmin_name"></el-input>
        </el-form-item>

        <el-form-item label="创建时间">
          <el-date-picker
            v-model="filter_form.createtime"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="goSearch"
          >搜索</el-button
        >
      </el-form>
    </div>

    <div class="task_box">
      <!-- 表格数据 -->
      <el-table :data="dataShow" border height="550">
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column
          property="connectionessay_name"
          label="书名"
          align="center"
          sortable
          :width="equipmentType == 0 ? 600 : 90"
        >
        </el-table-column>
        <el-table-column
          property="connection_name"
          label="金主昵称"
          align="center"
          sortable
          :width="equipmentType == 0 ? 300 : 110"
        >
        </el-table-column>
        <el-table-column
          property="writeradmin_name"
          label="写手编辑昵称"
          align="center"
          sortable
          :width="equipmentType == 0 ? 300 : 130"
        >
        </el-table-column>
        <el-table-column
          property="createtime"
          label="创建时间"
          align="center"
          sortable
        >
        </el-table-column>
        <el-table-column
          :fixed="equipmentType == 1 ? false : 'right'"
          label="操作"
          align="center"
          :width="equipmentType == 0 ? 150 : 101"
        >
          <template slot-scope="scope">
            <div class="highSeas_box">
              <div @click="filesRecord(scope.row)" class="remark_btn">
                <i class="iconfont icon-jilu"></i>
                上传记录
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        class="pagination_box"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 文件下载记录弹窗 -->
    <el-dialog
      :visible.sync="fileDialogVisible"
      title="文件下载记录"
      @close="cancelDialog"
    >
      <el-table :data="dataShowDialog" border>
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column
          property="writeradmin_nickname"
          sortable
          label="写手昵称"
          align="center"
          width="200"
        ></el-table-column>
        <el-table-column
          property="connectionessay_name"
          sortable
          label="书名"
          align="center"
          width="200"
        ></el-table-column>
        <el-table-column
          property="createtime"
          sortable
          label="创建时间"
          align="center"
        ></el-table-column>
        <el-table-column
          :fixed="equipmentType == 1 ? false : 'right'"
          label="操作"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <div class="highSeas_box">
              <div @click="downloadFile(scope.row)" class="remark_btn">
                <i class="iconfont icon-xiazai"></i>
                下载文件
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChangeDialog"
        @current-change="handleCurrentChangeDialog"
        :current-page="currentPageDialog"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSizeDialog"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalDialog"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>
<script>
import {
  connectionessay_file_list,
  connectionessay_file_log
} from "@/utils/owner";
export default {
  data() {
    return {
      baseUrl: this.$global.commonUrl, //路径
      ownerId: "", //金主所需部门id
      fileList: [], //书籍列表
      fileDialogList: [], //弹窗文件上传列表
      isFilterForm: true, //筛选按钮
      fileDialogVisible: false, //上传记录弹窗
      dataShow: [], // 当前页要显示的数据,
      totalPageData: [], // 分页数据(全部数据已经分好页)
      pageNum: 1, // 共几页
      pageSize: 100, // 每页显示数量
      currentPage: 1, // 当前显示页码
      total: 1, // 总共多少条数据
      // 筛选
      filter_form: {
        connection_name: "", //金主昵称
        connectionessay_name: "", //书名
        writeradmin_name: "", //写手编辑昵称
        createtime: "" //创建时间
      },
      dataShowDialog: [], //弹窗显示的数据
      totalPageDataDialog: [], // 分页数据(全部数据已经分好页)
      pageNumDialog: 1, // 共几页
      pageSizeDialog: 10, // 每页显示数量
      currentPageDialog: 1, // 当前显示页码
      totalDialog: 1, // 总共多少条数据
      select_time_data: "",
      time_filter: "", //时间筛选
      equipmentType: 0 //设备 0-pc端 1移动端
    };
  },
  created() {
    this.ownerId = JSON.parse(localStorage.getItem("userInfo")).id;
    if (this.$isMobile.isDeviceType()) {
      this.equipmentType = 1;
    } else {
      this.equipmentType = 0;
    }
    this.getFileList(); //任务中心列表
  },
  methods: {
    // 获取书籍下载列表
    getFileList() {
      var that = this;
      let obj = {
        departmentuser_id: that.ownerId
      };
      connectionessay_file_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.fileList = res.data.data;
          that.calcPageData();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },

    // 筛选
    goSearch(val) {
      var that = this;
      var date1, date2;
      that.select_time_data = that.filter_form.createtime;
      date1 = that.select_time_data[0];
      date2 = that.select_time_data[1];
      if (val == 0) {
        var time1, time2;
        time1 = that.select_time_data[0];
        time2 = that.select_time_data[1];
        that.time_filter = time1 + " - " + time2;
        that.filter_form.createtime = that.time_filter;
      } else {
        if (date1 == undefined && date2 == undefined) {
          that.time_filter = "";
        } else {
          that.time_filter = date1 + " - " + date2;
        }
        that.filter_form.createtime = that.time_filter;
      }
      let obj = {
        departmentuser_id: that.ownerId,
        ...that.filter_form
      };
      connectionessay_file_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.fileList = res.data.data;
          that.calcPageData();
          that.filter_form.createtime = that.select_time_data;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 获取上传记录列表-弹窗
    filesRecord(val) {
      var that = this;
      that.fileDialogVisible = true;
      let obj = {
        departmentuser_id: that.ownerId,
        connectionessay_id: val.id
      };
      connectionessay_file_log(obj).then(res => {
        if (res.data.code == 1) {
          that.totalDialog = res.data.data.length;
          that.fileDialogList = res.data.data;
          that.calcPageDataDialog();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 文件下载
    downloadFile(val) {
      var that = this;
      var fileUrl = val.file;
      var file_name = val.filename;
      if (fileUrl == "") {
        that.$message.error("暂无可下载文件");
      } else {
        let url = that.baseUrl + fileUrl;
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        // link.download = file_name; //设置文件名
        console.log("文件名", file_name);
        link.setAttribute("download", file_name);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    // 打开筛选表单
    show_filter_form() {
      var that = this;
      that.isFilterForm = !that.isFilterForm;
    },
    // 关闭弹窗触发
    cancelDialog() {
      this.goSearch(0);
    },
    // 列表分页
    calcPageData() {
      if (this.fileList.length > 1) {
        this.pageNum = Math.ceil(this.fileList.length / this.pageSize) || 1;
      }
      for (let i = 0; i < this.pageNum; i++) {
        this.totalPageData[i] = this.fileList.slice(
          this.pageSize * i,
          this.pageSize * (i + 1)
        );
      }
      this.dataShow = this.totalPageData[this.currentPage - 1];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.calcPageData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.dataShow = this.totalPageData[val - 1];
    },
    // 弹窗分页
    calcPageDataDialog() {
      if (this.fileDialogList.length > 1) {
        this.pageNumDialog =
          Math.ceil(this.fileDialogList.length / this.pageSizeDialog) || 1;
      }
      for (let i = 0; i < this.pageNumDialog; i++) {
        this.totalPageDataDialog[i] = this.fileDialogList.slice(
          this.pageSizeDialog * i,
          this.pageSizeDialog * (i + 1)
        );
      }
      this.dataShowDialog = this.totalPageDataDialog[
        this.currentPageDialog - 1
      ];
    },
    handleSizeChangeDialog(val) {
      this.pageSizeDialog = val;
      this.calcPageDataDialog();
    },
    handleCurrentChangeDialog(val) {
      this.currentPageDialog = val;
      this.dataShowDialog = this.totalPageDataDialog[val - 1];
    }
  }
};
</script>
<style scoped>
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}
.owner_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
  border: 1px solid #e4e9f1;
}

.sea_tag .el-tag.el-tag--info {
  width: 90px;
  margin: 5px auto;
}
.remark_btn {
  width: 90px;
  height: 20px;
  line-height: 20px;
  background: #e7f2ff;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #157df8;
  border-radius: 10px;
}
.remark_btn i {
  font-size: 12px;
}
.task_box {
  margin: 0 15px;
}
.task_filtrate {
  text-align: right;
  padding: 10px 15px 10px 15px;
}
.task_filtrate i {
  font-size: 14px;
}
.task_filtrate span {
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #8893a7;
}
.filter_form {
  background: #ffffff;
  margin: 0px 16px;
  padding-top: 15px;
}

.pagination_box {
  float: right;
  margin-top: 15px;
  margin-right: 15px;
}
.myowner_btn {
  width: 110px;
  height: 20px;
  line-height: 20px;
  background: #157df8;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  border-radius: 17px;
  margin-right: 5px;
}
.highSeas_box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.sea_tag {
  text-align: center;
}
@media screen and (max-width: 750px) and (min-width: 375px) {
  .task_box {
    margin-bottom: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/owner/DownloadFileRecord.vue